import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import { pensionTariffs } from '../../../../services/urls/urls';
import FAQStorybook from '@abank/abank-faq';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';
import tariffsData from '../enums//tariffs_data.json';
import additional_cards from '../enums/additional_cards_data.json';
import how_to_block_items from '../enums/how_to_block_items.json';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'yellow-card-new';

    const tabs = [{tab: 'tariffs', title: 'YELLOW_CARD_NEW_TABS_TITLE_01'},
          {tab: 'how-to', title: 'YELLOW_CARD_NEW_TABS_TITLE_02'}];

    const hero_data = {
      title: 'YELLOW_CARD_NEW_HERO_TITLE',
      text: 'YELLOW_CARD_NEW_HERO_TEXT',
      link: {
        text: "YELLOW_CARD_NEW_HERO_BTN",
        onClick: () => this.toggleModal(),
      },
      cards: [
        {
          title: 'YELLOW_CARD_NEW_CARDS_HERO_TITLE_01',
          text: 'YELLOW_CARD_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'YELLOW_CARD_NEW_CARDS_HERO_TITLE_02',
          text: 'YELLOW_CARD_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'YELLOW_CARD_NEW_CARDS_HERO_TITLE_03',
          text: 'YELLOW_CARD_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    }

    const imagesMap = {
      additional_product_img_1,
      additional_product_img_2,
      how_to_block_img_1,
      how_to_block_img_2,
      how_to_block_img_3,
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const howToBlockItems = how_to_block_items.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="yellow-card-new">
        <Hero
          data={hero_data}
          img={hero_img}
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <AdvantagesAdmin
                data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
                loader={this.state.loader}
              />
              <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
                <Tariffs
                  items={tariffsData}
                  title={'YELLOW_CARD_NEW_CARDS_TARIFFS_TITLE'}
                  btnLink={pensionTariffs}
                  btnText={'YELLOW_CARD_NEW_CARDS_TARIFFS_BTN'}
                  page={page}
                />
                <HowToBlockNew
                  title={'YELLOW_CARD_NEW_HOW_TO_TITLE'}
                  items={howToBlockItems}
                />
              </Tabs>
              <AdditionalProduct
                items={additionalCards}
                title={'YELLOW_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                page={page}
              />
              <QuestionsAdminNew
                page={page}
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'FAQ_SHORT_NEW_TITLE'}
              />
              <FilesForDownloadNew
                lang={this.props.lang}
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
        {this.state.showModal ? 
          <CardOrderModal closeModal={this.toggleModal} product={"yellow"} isOpen={this.state.showModal}/> : ''
        }
      </div>
    );
}
